import { ApiProperty } from '@nestjs/swagger'

export class TeachingStudentUserIdsItemDto {
  @ApiProperty()
  teachingId: string

  @ApiProperty({ type: [String], description: 'UUIDs élèves (rôle STUDENT ou groupe)' })
  userIds: string[]
}

export class TeachingStudentUserIdsBatchResponseDto {
  @ApiProperty({ type: [TeachingStudentUserIdsItemDto] })
  results: TeachingStudentUserIdsItemDto[]
}
